// extracted by mini-css-extract-plugin
module.exports = {"topBar":"style_topBar__1dziD","logo":"style_logo__2p7pO"};